import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'recompose';

import ggStore from 'ggApp/modules/store';
import ggRentalPlan, { getPrices } from 'ggApp/modules/rentalPlan';

import ProductCtaComponent from 'ggApp/shared/components/BaseLayout/ProductCta';

const MobileCta = ({
    activeStore,
    selectedRentalPlan,
    className,
    onCtaClick,
    accentColor,
    isAvailable,
    preorderProduct,
}) => {
    const { price, oldPrice } = getPrices(activeStore, selectedRentalPlan);
    return (
        <ProductCtaComponent
            className={className}
            accentColor={accentColor}
            price={price}
            oldPrice={oldPrice}
            selectedPlan={selectedRentalPlan}
            onCtaClick={onCtaClick}
            currentlyAvailable={isAvailable}
            ctaTk={preorderProduct ? 'PREORDER_CTA' : 'PRODUCT_CARD_CTA_LABEL_MOBILE'}
        />
    );
};

MobileCta.propTypes = {
    activeStore: PropTypes.shape({}).isRequired,
    selectedRentalPlan: PropTypes.shape({}).isRequired,
    onCtaClick: PropTypes.func.isRequired,
    className: PropTypes.string,
    accentColor: PropTypes.string,
    isAvailable: PropTypes.bool,
};

MobileCta.defaultProps = {
    className: undefined,
    accentColor: null,
    isAvailable: false,
};

export default compose(
    connect(
        createStructuredSelector({
            activeStore: ggStore.selectors.storeActive,
            rentalPlans: ggRentalPlan.selectors.currentProductRentalPlans,
            selectedRentalPlan: ggRentalPlan.selectors.selectedRentalPlanSelector,
        }),
    ),
)(MobileCta);
